import React, { useEffect, useState } from "react";
import {
  Button,
  InputGroup,
  Form,
  FormControl,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineCheckSquare } from "react-icons/ai";
import DatePicker from "react-datepicker";
import { FaTimes, FaCoffee } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../Navigation/Auth/ProvideAuth";
import { STATUS_AND_TYPES, PATH } from "../../config";
import {
  CheckoutAction,
  employeeShortLeaveAction,
  getBreak,
  lateCheckInAction,
  LeaveRequestAction,
  MarkAttendanceAction,
  ShortBreakAction,
  ShortLeaveAction,
} from "../../redux/actions";
import { useForm } from "react-hook-form";
import { FieldError } from "../../assets";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { successNoti, errorNoti } from "../../assets/Notifications/index";
import { shortLeaveRequest } from "../../redux/api";
import {useLeaveRequestMutation} from "../../redux/features/user/user.slice";
import { Loader } from "./Loader";
import { useCookies } from "react-cookie";
import { ErrorMessage } from ".";
import { useHistory } from "react-router-dom";
import { LeaveRequestDTO } from "../../requestDTO/Attendance/LeaveRequestDTO";
import { getDateInFormat } from "../../assets/genericAction/index";
import { CheckAttendanceStatus } from "../../redux/actions";
import { ShortBreakDTO } from "../../requestDTO/Attendance/ShortBreakDTO";

function CheckInOutButtons() {
  const auth = useAuth();
  let dispatch = useDispatch();
  let empAttendance = useSelector((state) => state.attendance);
  const [openTab, setOpenTab] = useState(0);

  function OnShortBreakView() {
    dispatch(CheckAttendanceStatus(auth.user.token));
  }

  //redcuer object name
  //empAttendance.empTodayAttendance
  return (
    <>
      <div
        className="AttendanceCheckInButton"
        onClick={() => {
          setOpenTab(2);
        }}
      >
        <Button variant="primary" className="check-in-out-btn">
          <AiOutlineCheckSquare className="mr-1" />
          {/*{"CheckIn/Out"}*/}
          {"Leave"}
        </Button>
      </div>
      {/*<div*/}
      {/*  className="RightSideButton"*/}
      {/*  onClick={() => {*/}
      {/*    setOpenTab(1);*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Button*/}
      {/*    variant="primary"*/}
      {/*    className="check-in-out-btn"*/}
      {/*    onClick={() => OnShortBreakView()}*/}
      {/*  >*/}
      {/*    <FaCoffee className="mr-1" />*/}
      {/*    {"Short break"}*/}
      {/*  </Button>*/}
      {/*</div>*/}
      {openTab === 1 && (
        <BreakForm
          openTab={openTab}
          setOpenTab={setOpenTab}
          attendanceStatus={empAttendance && empAttendance.empTodayAttendance}
        />
      )}
      {openTab === 2 && (
        <CheckOutForm openTab={openTab} setOpenTab={setOpenTab} />
      )}
    </>
  );
}

function BreakForm(props) {
  let auth = useAuth();
  let dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();
  let attendance = useSelector((state) => state.attendance);

  //console.log('break satatus :::', props.attendanceStatus);

  function applyBreak(data) {
    ShortBreakDTO.isStartBreak = true;
    ShortBreakDTO.reason = data.reason;
    ShortBreakDTO.breakType = data.breakTypeId;
    dispatch(ShortBreakAction(ShortBreakDTO, auth.user.token));
  }

  return (
    <div className={`ShortBreak_sidebar ${props.openTab === 1 ? "open" : ""}`}>
      <Link
        to="#"
        className="p-3  ShortBreakBar float-right"
        onClick={() => {
          props.setOpenTab(0);
        }}
      >
        <FaTimes />
      </Link>
      <h4 className=" tabscolor padding14rem bottom-set-divider">
        {"Take Break"}
      </h4>
      <div className="shortBreakContent">
        <div className="card w-90">
          <h3>{"Hey! You Want a Break ? "}</h3>
          <hr />
          <form onSubmit={handleSubmit(applyBreak)}>
            <div className="row">
              <div className="col-sm-12 ">
                <div className="form-group">
                  <Form.Group controlId="exampleForm.ControlSelect1">
                    <Form.Label className="text-bold">
                      {"Select Type"}
                    </Form.Label>
                    <Form.Control
                      className="mb-1 "
                      as="select"
                      name={"breakTypeId"}
                      ref={register({ required: true })}
                    >
                      <option value="">{"--Select Type--"}</option>
                      {STATUS_AND_TYPES &&
                        STATUS_AND_TYPES.BREAK_TYPES &&
                        STATUS_AND_TYPES.BREAK_TYPES.map((breakType, index) => {
                          return (
                            <option key={index} value={breakType.breakTypeId}>
                              {breakType.title}
                            </option>
                          );
                        })}
                    </Form.Control>
                  </Form.Group>
                  {errors.breakTypeId && (
                    <FieldError message={"This field is required."} />
                  )}
                </div>
                <div className="form-group">
                  <textarea
                    ref={register()}
                    name="reason"
                    className="form-control"
                    rows={3}
                    placeholder="Reason for break"
                  />
                </div>
                <div className="text-right submission-data takeBreak">
                  <a
                    onClick={() => {
                      props.setOpenTab(0);
                    }}
                    className="btn btn-sm btn-default ShortBreakBar"
                  >
                    {"Cancel"}
                  </a>
                  {props.attendanceStatus &&
                  props.attendanceStatus.isOnShortBreak &&
                  props.attendanceStatus.isOnShortBreak === true ? (
                    <button
                      disabled
                      type="submit"
                      className="btn btn-sm btn-success btn-primary ml-1"
                    >
                      {"Already On Break"}
                    </button>
                  ) : attendance && attendance.shortBreakLoading ? (
                    <Loader />
                  ) : attendance && attendance.shortBreakSuccess ? (
                    <button
                      disabled
                      type="submit"
                      className="btn btn-sm btn-success btn-primary ml-1"
                    >
                      {"Done!"}
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-sm btn-success btn-primary ml-1"
                    >
                      {"Start Now"}
                    </button>
                  )}
                  {attendance && attendance.shortBreakFailure && (
                    <ErrorMessage
                      message={
                        attendance && attendance.shortBreakError
                          ? attendance.shortBreakError
                          : ""
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer transition={Slide} />
    </div>
  );
}
function CheckOutForm({setOpenTab,openTab}) {
  let auth = useAuth();
  let dispatch = useDispatch();
  let history = useHistory();
  const [cookies, removeCookie] = useCookies(["user"]);
  const [activeTab, setActiveTab] = useState(1);
  const [leaveTab, setLeaveTab] = useState(0);
  const [leaveRequest] = useLeaveRequestMutation();

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const { register, handleSubmit, errors } = useForm();
  let attendance = useSelector((state) => state.attendance);
  const [show, setShow] = useState(false);
  // function checkOut() {
  //     dispatch(MarkAttendanceAction(auth.user.token, closePopup, callCheckoutReasonPopup))
  // }

  function checkout() {
    setActiveTab(0);
    dispatch(CheckoutAction(auth.user.token));
    removeCookie("user", { path: "/", domain: ".visioncollab.com" });
  }

  async function LeaveRequest(data) {
    LeaveRequestDTO.leaveFrom = getDateInFormat(data.LeaveStartDate);
    LeaveRequestDTO.leaveTo = getDateInFormat(data.LeaveEndDate);
    LeaveRequestDTO.reason = data.reason;
    const {data:respData} = await leaveRequest({payload:LeaveRequestDTO,token:auth.user.token}) ;
    if(["200","1",1,200].includes(respData?.status)){
      setOpenTab(null)
    }
  }

  function shortLeave(data) {
    setActiveTab(0);
    dispatch(ShortLeaveAction(data.reason, auth.user.token));
  }

  useEffect(() => {
    // logout if checked out or applied for short leave
    if (
      (attendance && attendance.getShortLeaveSuccess) ||
      (attendance && attendance.checkoutSuccess)
    ) {
      history.push(PATH.LOGIN);
    }
  }, [attendance.getShortLeaveSuccess]);

  function callCheckoutReasonPopup(data) {
    if (data.status === 9) {
      setShow(true);
    }
  }

  function shortLeaveActionCallBack(data) {
    if (data.status == 1) {
      successNoti(data.message);
    } else {
      errorNoti(data.message);
    }
  }

  //Full leave handlers

  return (
    <>
      <div
        className={`AttendanceCheckIn_sidebar ${
          openTab === 2 ? "open" : ""
        }`}
      >
        <Link
          to="#"
          className="p-2 CheckIn_sidebar float-right"
          onClick={() => {
            setOpenTab(0);
          }}
        >
          <FaTimes size={20} />
        </Link>
        <ul className="nav nav-tabs" role="tablist">
          {/*<li className="nav-item">*/}
          {/*  <Link*/}
          {/*    to="#"*/}
          {/*    className={`nav-link tabscolor ${*/}
          {/*      activeTab === 0 ? "active" : ""*/}
          {/*    }`}*/}
          {/*    onClick={() => {*/}
          {/*      setActiveTab(0);*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    {"Checkout"}*/}
          {/*  </Link>*/}
          {/*</li>*/}
          <li className="nav-item">
            <Link
              to="#"
              className={`nav-link tabscolor ${
                activeTab === 1 ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(1);
              }}
            >
              {"Leave"}
            </Link>
          </li>
        </ul>
        <div className="tab-content">
          <div className="tab-pane vivify fadeIn active checkoutBtn">
            {activeTab === 0 && (
              <div className="card px-3">
                <h3 className="mb-2">{"Are you going to checkout?"}</h3>
                {attendance && attendance.employeeCheckInOrOutLoading ? (
                  <Loader />
                ) : (
                  <button
                    type="submit"
                    className="btn btn-sm btn-info btn-primary mr-3 mt-1"
                    onClick={() => {
                      checkout();
                    }}
                  >
                    {"CHECK OUT"}
                  </button>
                )}
                <form onSubmit={handleSubmit(shortLeave)}>
                  <div className="row checkout-leave mt-4">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="text-bold mb-1">
                          {"Reason"}
                          <span className="required"> *</span>
                        </label>
                        <textarea
                          name="reason"
                          ref={register({ required: true })}
                          className="form-control"
                          rows={3}
                          placeholder="Reason for short leave?"
                        />
                      </div>
                      {errors.reason && (
                        <FieldError message={"This field is required."} />
                      )}

                      <div className="text-right submission-data mt-3">
                        <Link
                          to="#"
                          onClick={() => {
                            setOpenTab(0);
                          }}
                          className="btn btn-sm btn-default mr-1"
                        >
                          {"Cancel"}
                        </Link>
                        {attendance && attendance.getShortLeaveLoading ? (
                          <Loader />
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-sm btn-info btn-primary"
                          >
                            {"Short Leave"}
                          </button>
                        )}
                        {attendance && attendance.getShortLeaveFailure && (
                          <ErrorMessage
                            message={attendance.getShortLeaveError}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
            {activeTab === 1 && (
              <div className="row">
                {/* <div className="d-flex align-items-center justify-content-start ml-3 mb-3">
                  <div className="col-4 col-md-4">
                    <Dropdown>
                      <Dropdown.Toggle className="ceo-dropdown">
                        Select Leave Type
                      </Dropdown.Toggle>
                      <Dropdown.Menu className=" dropdown-menu shadow bg-white dropdown-menu-activ-color">
                        <Dropdown.Item onClick={() => setLeaveTab(0)}>
                          {"Full Day Leave"}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setLeaveTab(1)}>
                          {"Short Leave"}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div> */}

                <div className="col-md-12 col-sm-12 checkout-leave">
                  {/* {leaveTab === 0 && ( */}
                  <form onSubmit={handleSubmit(LeaveRequest)}>
                    <div className="col-md-12 col-lg-12">
                      <label className="text-bold mb-1">
                        {"Start Date"} <span className="required">* </span>
                      </label>
                      <InputGroup>
                        <DatePicker
                          className="form-control"
                          placeholderText="From Date"
                          selected={fromDate}
                          onChange={(date) => setFromDate(date)}
                          isClearable
                        />
                      </InputGroup>
                      <input
                        value={fromDate}
                        ref={register({ required: true })}
                        name="LeaveStartDate"
                        style={{ display: "none" }}
                      />
                      {errors.LeaveStartDate && (
                        <FieldError message={"Start Date is required."} />
                      )}
                    </div>
                    <div className="col-md-12">
                      <label className="text-bold mb-1 mt-3">
                        {"End Date"}
                        <span className="required"> *</span>
                      </label>
                      <InputGroup>
                        <DatePicker
                          className="form-control"
                          placeholderText="To Date"
                          name="LeaveEndDate"
                          selected={toDate}
                          onChange={(date) => setToDate(date)}
                          isClearable
                        />
                      </InputGroup>
                      <input
                        value={toDate}
                        ref={register({ required: true })}
                        name="LeaveEndDate"
                        style={{ display: "none" }}
                      />
                      {errors.LeaveEndDate && (
                        <FieldError message={"End Date is required."} />
                      )}
                    </div>
                    <div className="form-group px-3">
                      <label className="text-bold mb-1 mt-3">
                        {"Reason"}
                        <span className="required"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        name="reason"
                        ref={register({ required: true })}
                        id="ReasonLeave"
                        rows={3}
                        placeholder="Reason for Leave"
                      />
                      {errors.reason && (
                        <FieldError message={"Reason is required."} />
                      )}
                    </div>
                    <div
                      className="text-right"
                      style={{ marginTop: 10, position: "relative" }}
                    >
                      {attendance && attendance.lateCheckInLoading === true ? (
                        <Loader />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-sm btn-info btn-primary mr-3 mt-1"
                        >
                          {"Submit"}
                        </button>
                      )}
                    </div>
                  </form>
                  {/* )} */}
                  {/* {leaveTab === 1 && (
                    <div className="col-md-12 col-sm-12 checkout-leave">
                      <form onSubmit={handleSubmit(shortLeave)}>
                        <div className="row checkout-leave">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="text-bold mb-1">
                                {"Reason"}
                                <span className="required">* </span>
                              </label>
                              <textarea
                                name="reason"
                                ref={register({ required: true })}
                                className="form-control"
                                rows={3}
                                placeholder="Reason for short leave?"
                              />
                            </div>
                            {errors.reason && (
                              <FieldError message={"This field is required."} />
                            )}

                            <div className="text-right submission-data mt-3">
                              <Link
                                to="#"
                                onClick={() => {
                                  props.setOpenTab(0);
                                }}
                                className="btn btn-sm btn-default mr-1"
                              >
                                {"Cancel"}
                              </Link>
                              {attendance && attendance.getShortLeaveLoading ? (
                                <Loader />
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-sm btn-info btn-primary"
                                >
                                  {"Short Leave"}
                                </button>
                              )}
                              {attendance &&
                                attendance.getShortLeaveFailure && (
                                  <ErrorMessage
                                    message={attendance.getShortLeaveError}
                                  />
                                )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )} */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <CheckoutPendingWorkReason show={show} setShow={setShow} />
      <ToastContainer />
    </>
  );
}
function CheckoutPendingWorkReason(props) {
  let attendance = useSelector((state) => state.attendance);
  //console.log('attendance', attendance);
  let dispatch = useDispatch();
  let auth = useAuth();
  const { register, handleSubmit, errors, reset } = useForm();

  function closePopup(data) {
    if (data.status == 1) {
      props.setShow(false);
      successNoti(data.message);
    } else {
      errorNoti(data.message);
    }
  }

  const onFormSubmit = (data) => {
    var reasons = [];
    reasons.push({ ReasonType: 1, Reason: data.taskNotCreatedReason });
    reasons.push({ ReasonType: 2, Reason: data.tasNotCompletedReason });
    reasons.push({ ReasonType: 3, Reason: data.todoNotCompletedReason });
    data.status = STATUS_AND_TYPES.CHECKINOUT.CheckOut;
    data.isDirectCheckout = false;
    data.reasons = reasons;
    data.createdById = auth.user.userId;
    dispatch(MarkAttendanceAction(data, auth.user.token, closePopup));
  };
  return (
    <Modal
      {...props}
      show={props.show}
      onHide={() => {
        props.setShow(false);
      }}
      size="sm"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="kanban-add-task-modal-header" closeButton>
        <Modal.Title className="text-uppercase">
          {"Mention Reason for Pending Work"}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-12">
                <label className="salary-labels">
                  {"Reason for no task created:"}
                </label>

                <textarea
                  className="form-control"
                  placeholder="Enter reason here"
                  name="taskNotCreatedReason"
                  ref={register({ required: "This field is required." })}
                />

                {errors && errors.taskNotCreatedReason && (
                  <FieldError message={errors.taskNotCreatedReason.message} />
                )}
              </div>
              <div className="col-12">
                <label className="salary-labels">
                  {"Reason for task not completed:"}
                </label>

                <textarea
                  className="form-control"
                  placeholder="Enter reason here"
                  name="tasNotCompletedReason"
                  ref={register({ required: "This field is required." })}
                />

                {errors && errors.tasNotCompletedReason && (
                  <FieldError message={errors.tasNotCompletedReason.message} />
                )}
              </div>
              <div className="col-12">
                <label className="salary-labels">
                  {"Reason for todo not completed:"}
                </label>

                <textarea
                  className="form-control"
                  placeholder="Enter reason here"
                  name="todoNotCompletedReason"
                  ref={register({ required: "This field is required." })}
                />

                {errors && errors.todoNotCompletedReason && (
                  <FieldError message={errors.todoNotCompletedReason.message} />
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="container-fluid">
            <div className="row justify-content-end">
              <div className="col-12 d-flex justify-content-end">
                {attendance &&
                attendance.employeeCheckInOrOutLoading === true ? (
                  <Loader />
                ) : (
                  <Button
                    type="submit"
                    bsPrefix="vc-generic-btn"
                    className="rounded f-14"
                  >
                    {"Checkout"}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
export { CheckInOutButtons };
